export const priceComma = (e) => {
  const a = e;
  return Number(a).toLocaleString("ko-KR");
};
